import { apiClient } from "./client";

// Сторінка «Газ» (FR-UI-GAS). Факт із лічильника поруч із паспортною кривою.

export interface GasDay {
  day: string;
  generation_hours: number;
  gas_hours: number;
  gas_m3: number | null;
  generation_kwh: number | null;
  cost_uah: number | null;
}

export interface GasHour {
  ts: string;
  generation_kwh: number | null;
  gas_m3: number | null;
  /** `null`, якщо генерації не було — питому витрату рахувати нема від чого. */
  gas_m3_per_mwh: number | null;
  cost_uah: number | null;
}

export interface GasPreset {
  /** `min` | `mid` | `max` */
  label: string;
  power_kw: number;
  power_pct: number;
  /** `null`, якщо годин на цьому режимі в періоді не було. */
  fact_m3h: number | null;
  curve_m3h: number | null;
  diff_pct: number | null;
  hours: number;
}

export interface GasStart {
  ts: string;
  hours: number;
  gas_m3: number;
  productive_m3: number;
  /** Непродуктивний газ пуску = gas_m3 − productive_m3. */
  start_m3: number;
  cost_uah: number | null;
}

export interface GasCurvePoint {
  power_kw: number;
  gas_m3h: number;
}

/** Фактична собівартість у кошику потужності по 50 кВт (Σ витрат / Σ виробітку). */
export interface GasCostPoint {
  power_kw: number;
  cost_uah_per_mwh: number;
  hours: number;
}

export interface GasSummary {
  from_date: string;
  to_date: string;
  days: GasDay[];
  presets: GasPreset[];
  curve: GasCurvePoint[];
  fact_points: GasCurvePoint[];
  /** Пара до паспортної кривої `/cost-curve`, порожній масив без лічильника газу. */
  fact_cost_points: GasCostPoint[];
  prepaid_remaining_m3: number | null;
  /** Пуски КГУ. Зупинки не рахуємо: газ на них не витрачається. */
  starts: GasStart[];
  starts_total_m3: number;
  starts_total_uah: number | null;
  /** Заміряна витрата на номіналі — база розрахунку пусків. */
  full_load_rate_m3h: number | null;
}

export const gasApi = {
  summary: (from: string, to: string) =>
    apiClient.get<GasSummary>("/gas/summary", { params: { from, to } }).then((r) => r.data),
  hourly: (date: string) =>
    apiClient.get<GasHour[]>("/gas/hourly", { params: { date } }).then((r) => r.data),
};
